<template>
  <div v-if="isShow" class="box_da ly-border-radius">
    <div class="content">
      <el-form
        label-width="120px"
        :model="chainData"
        ref="chainRef"
        :rules="chainRule"
      >
        <div class="mainTop">
          <el-form-item label="场景类型">
            <el-radio-group v-model="chainData.sceneType">
              <el-radio label="通用场景"></el-radio>
              <el-radio label="行业场景"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="场景名称："
            style="width: 470px"
            prop="sceneName"
          >
            <el-input v-model="chainData.sceneName"></el-input>
          </el-form-item>
          <el-form-item label="上级场景：" style="width: 470px" prop="">
            <el-select
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              v-model="chainData.superiorSceneId"
            >
              <el-option
                v-for="item in sceneList"
                :key="item.id"
                :label="item.sceneName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="上级行为："
            style="width: 470px"
            prop="superiorBehaviorId"
          >
            <el-select
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethods"
              v-model="chainData.superiorBehaviorId"
            >
              <el-option
                v-for="item in sceneArr"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场景图片：">
            <UploadImage
              @upLoadImgList="lookClick"
              @upOldLoadImgList="saveClick"
              :upLoadImgList.sync="chainData.sceneImgUrl"
              :upOldLoadImgList.sync="chainData.sceneImgList"
            />
          </el-form-item>
          <el-form-item label="国民经济行业标签组：" label-width="160px">
            <IndustryLabelGroup
              :industrylist="industrylist"
              @industry-change="collectIndustryChecked"
            />
          </el-form-item>

          <el-form-item label="所属产业链：">
            <el-select
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入所属产业链"
              :remote-method="selectAllIndustrialChainName"
              v-model="chainData.industrialChain"
            >
              <el-option
                v-for="(item, i) in industrialChainOptions"
                :key="i"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属产品：">
            <el-input v-model="chainData.affiliatedProducts"></el-input>
          </el-form-item>
          <el-form-item label="所属行为：">
            <el-checkbox-group v-model="chainData.enterpriseBehaviorLabels">
              <!-- 显示 typelist -->
              <el-checkbox
                v-for="(o, i) in behaviorOptions"
                :label="o.codeName"
                :key="i"
              >
                <!-- 锚点 -->
                <span>{{ o.codeName }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="所属生产工艺："
            label-width="140px"
            style="width: 470px"
            prop=""
          >
            <el-input
              disabled
              v-model="chainData.value"
              placeholder="请输入所属生产工艺"
            ></el-input>
          </el-form-item>

          <el-form-item label="潜在痛点：">
            <el-input
              style="width: 50%"
              maxlength="100"
              show-word-limit
              v-model="chainData.potentialPainPoint"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="场景描述：">
            <el-input
              style="width: 50%"
              maxlength="100"
              show-word-limit
              v-model="chainData.sceneDescribe"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="场景现状：">
            <Editorbar
              v-model="chainData.sceneSituation"
              :isClear="isClear"
              style="width: 50%"
            />
          </el-form-item>

          <el-form-item
            label="关联企业："
            style="width: 470px"
            prop="associatedCompanyIdList"
          >
            <el-select
              filterable
              remote
              multiple
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethodssss"
              v-model="chainData.associatedCompanyIdList"
              @change="clickCompany"
            >
              <el-option
                v-for="item in sceneArr2"
                :key="item.id"
                :label="item.companyFullName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联产品：" style="width: 470px" prop="">
            <el-select
              filterable
              clearable
              multiple
              remote
              value-key="productCode"
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethodsss"
              v-model="chainData.productResults"
            >
              <el-option
                v-for="item in sceneArr1"
                :key="item.productCode"
                :label="item.productName"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="相关链接：">
            <el-input v-model="chainData.associatedCompanyUrl"></el-input>
          </el-form-item>
          <el-form-item
            label="技改需求："
            style="width: 470px"
            prop="technicalRenovationRequirements"
          >
            <el-input
              v-model="chainData.technicalRenovationRequirements"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所需技术："
            style="width: 470px"
            prop="requiredTechnology"
          >
            <el-input v-model="chainData.requiredTechnology"></el-input>
          </el-form-item>
          <el-form-item
            label="技改效益："
            style="width: 470px"
            prop="technicalRenovationBenefits"
          >
            <el-input
              v-model="chainData.technicalRenovationBenefits"
            ></el-input>
          </el-form-item>
          <div class="border_flex">
            <span class="border_left"></span>
            <span>收益</span>
          </div>

          <el-form-item label="短期收益：" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList2" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(2)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(2, i)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="长期收益：" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList3" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(3)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(3, i)"
              ></i>
            </div>
          </el-form-item>
          <div class="border_flex">
            <span class="border_left"></span>
            <span>风险</span>
          </div>
          <el-form-item label="管理风险" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList4" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(4)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(4, i)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="科技风险" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList5" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(5)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(5, i)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="合规风险" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList6" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(6)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(6, i)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="组织风险" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList7" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(7)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(7, i)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="舆论风险" style="width: 640px" prop="">
            <div class="circle_flex" v-for="(o, i) in qianList8" :key="i">
              <el-input
                maxlength="25"
                show-word-limit
                v-model="o.name"
              ></el-input>
              <i @click="addpush(8)" class="el-icon-circle-plus-outline"></i>
              <i
                v-if="i != 0"
                class="el-icon-remove-outline"
                @click="remove(8, i)"
              ></i>
            </div>
          </el-form-item>
          <div class="border_flex">
            <span class="border_left"></span>
            <span>投入</span>
          </div>
          <el-form-item
            label="科技建设："
            style="width: 470px"
            prop="technologyConstruction"
          >
            <el-input
              maxlength="25"
              show-word-limit
              v-model="chainData.technologyConstruction"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="运算资源："
            style="width: 470px"
            prop="computingResources"
          >
            <el-input
              maxlength="25"
              show-word-limit
              v-model="chainData.computingResources"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="数据与知识："
            style="width: 470px"
            prop="dataKnowledge"
          >
            <el-input
              maxlength="25"
              show-word-limit
              v-model="chainData.dataKnowledge"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="组织变革："
            style="width: 470px"
            prop="organizationalChange"
          >
            <el-input
              maxlength="25"
              show-word-limit
              v-model="chainData.organizationalChange"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="ess_people" v-if="personType">
        <div class="ess_people_list">创建人：{{ chainData.createName }}</div>
        <div class="ess_people_list">修改人：{{ chainData.updateName }}</div>
        <div class="ess_people_list">创建时间：{{ chainData.createTimes }}</div>
        <div class="ess_people_list">修改时间：{{ chainData.updateTimes }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import UploadImage from "../Exercise/ActiveData/uploadImage";
import Editorbar from "@/components/Editorbar";
import IndustryLabelGroup from "./components/IndustryLabelGroup.vue";
import {
  insertScenarioBasic,
  selectById,
  updateScenarioBasic,
  getDicRadioButton,
  selectAllIndustrialChainName,
  getAllIndustrialChainName,
  getIndustryThree,
  getLabel,
} from "@/api/Sceneknowledge.js";
import { getIndustryLabelFour } from "@/api/common.js";
import {
  selectAssociatedScenarios,
  selectAssociated,
  getProductByName,
  getZcByCompanyName,
  getAllScenarioProcess,
} from "@/api/standardKnowledge.js";
export default {
  name: "App",
  components: {
    DicCheckboxGroup,
    UploadImage,
    Editorbar,
    IndustryLabelGroup,
  },
  watch: {
    "chainData.id": {
      handler(newVal) {
        if (this.chainData && newVal) {
          this.isShow = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
   this.getDicRadioButton().then(() => {
      this.selectAllIndustrialChainName().then(() => {
        this.getIndustryThree().then(() => {
          setTimeout(() => {
            if (this.personType) {
              this.search().then(() => {});
            } else if (!this.personType) {
              this.isShow = true;
            }
          }, 500);
        });
      });
   });
  },
  computed: {
    personData() {
      return this.$route.query.id;
    },
    personType() {
      return Number(this.$route.query.personType);
    },
    Authorization() {
      return sessionStorage.getItem("token");
    },
  },
  data() {
    return {
      sceneList: [], //
      sceneArr: [],
      sceneArr1: [],
      sceneArr2: [],
      isClear: null,
      isShow: false,
      isShowManufacturingCategory: false,
      options: [],
      chainData: {
        associatedCompanyIdList: [],
        associatedCompanyNameList: [],
        sceneName: "", //场景名称
        sceneProperties: "通用场景", //场景属性
        // sceneDescribe: "", //场景描述
        // industryCategoriesList: [], //行业类别
        supplyChainIndustryChild: [],
        sceneImgList: [], //场景图片
        sceneImgUrl: [],
        associatedScenarios: "", //关联场景
        enterpriseBehaviorLabels: [], // 企业行为
        industrialChain: "", //产业链
        technicalRenovationRequirements: "", //技改需求
        requiredTechnology: "", //所需技术
        technicalRenovationBenefits: "", //技改效益

        industrialChainLabelList: [], //产业链标签
        manufacturingCategory: "", //生产制造类别
        sceneDescribe: "", //生产制造类别
        sceneSituation: "", //生产制造类别
        technicalSolution: "", //生产制造类别
        industryLabelList: [],
        longTermReturnsList: [], //长期收益
        manageRisksList: [], //管理风险
        organizationalRiskList: [], //组织风险
        potentialPainPointList: [], //潜在痛点
        publicOpinionRiskList: [], //舆论风险
        complianceRiskList: [], //
        shortTermGainsList: [], //短期收益
        technologicalRisksList: [], //技术风险
        incomeList: [], //收益
        scenarioLabelList: [],
        productResults: [],
        technicalRenovationRequirements: "",
        requiredTechnology: "",
        technicalRenovationBenefits: "",
      },
      rocessList: [],
      //潜在痛点
      qianList: [
        {
          name: "",
        },
      ],
      //收益
      qianList1: [
        {
          name: "",
        },
      ],
      //短期收益
      qianList2: [
        {
          name: "",
        },
      ],
      //长期收益
      qianList3: [
        {
          name: "",
        },
      ],
      //管理风险
      qianList4: [
        {
          name: "",
        },
      ],
      //科技风险
      qianList5: [
        {
          name: "",
        },
      ],
      //合规风险
      qianList6: [
        {
          name: "",
        },
      ],
      //组织风险
      qianList7: [
        {
          name: "",
        },
      ],
      //舆论风险
      qianList8: [
        {
          name: "",
        },
      ],
      associatedCompanyNameList: [],
      radiolist: [
        {
          typelist: [], //一级标签
          codechildlist1: [],
          childlist: [],
          childlist4: [],
          childcode5: [],
          childcode6: [],
          labelparam1: [],
          labelparam2: [],
          labelparam3: [],
          labelparam4: [],
          labelparam5: [],
          labelparam6: [],
        },
      ],

      //企业行为
      behaviorOptions: [],
      behaviorProps: {
        multiple: true,
        value: "codeName",
        label: "codeName",
        children: "childNode",
      },
      // 产业链行为
      industrialChainOptions: [],
      industrialChainProps: { value: "codeId", label: "codeName" },
      //产业链标签
      industryChainLabelOptions: [],
      industryChainLabelProps: {
        multiple: true,
        value: "id",
        label: "industrialName",
      },
      //行业标签
      industryThreeOptions: [],
      industrylist: [],
      industryThreeProps: {
        multiple: true,
        value: "id",
        label: "industryName",
        children: "childNode",
      },
      chainRule: {
        sceneName: [
          { required: true, message: "请填写场景名称", trigger: "blur" },
        ],
        sceneProperties: [
          { required: true, message: "请选择场景属性", trigger: "blur" },
        ],
        associatedCompanyIdList: [
          { required: true, message: "请选择企业", trigger: "blur" },
        ],
        superiorBehaviorId: [
          { required: true, message: "请选择上级行为", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    collectIndustryChecked() {
      const list = [];
      const one = this.industrylist[0];

      [
        "labelparam1",
        "labelparam2",
        "labelparam3",
        "labelparam4",
        "labelparam5",
        "labelparam6",
      ].forEach((key, idx) => {
        const childKey =
          idx === 0
            ? "typelist"
            : idx === 1
            ? "codechildlist1"
            : idx === 2
            ? "childlist"
            : idx === 3
            ? "childlist4"
            : idx === 4
            ? "childcode5"
            : "childcode6";

        one[key].forEach((id) => {
          const node = one[childKey].find((t) => t.id === id);
          if (node)
            list.push({ groupLabelName: node.industryName, labelId: id });
        });
      });

      this.chainData.scenarioLabelList = list;
    },
    addpush(index) {
      if (index == 0) {
        this.qianList.push({
          name: "",
        });
      } else if (index == 1) {
        this.qianList1.push({
          name: "",
        });
      } else if (index == 2) {
        this.qianList2.push({
          name: "",
        });
      } else if (index == 3) {
        this.qianList3.push({
          name: "",
        });
      } else if (index == 4) {
        this.qianList4.push({
          name: "",
        });
      } else if (index == 5) {
        this.qianList5.push({
          name: "",
        });
      } else if (index == 6) {
        this.qianList6.push({
          name: "",
        });
      } else if (index == 7) {
        this.qianList7.push({
          name: "",
        });
      } else if (index == 8) {
        this.qianList8.push({
          name: "",
        });
      }
    },
    remove(index, i) {
      if (index == 0) {
        this.qianList.splice(i, 1);
      } else if (index == 1) {
        this.qianList1.splice(i, 1);
      } else if (index == 2) {
        this.qianList2.splice(i, 1);
      } else if (index == 3) {
        this.qianList3.splice(i, 1);
      } else if (index == 4) {
        this.qianList4.splice(i, 1);
      } else if (index == 5) {
        this.qianList5.splice(i, 1);
      } else if (index == 6) {
        this.qianList6.splice(i, 1);
      } else if (index == 7) {
        this.qianList7.splice(i, 1);
      } else if (index == 8) {
        this.qianList8.splice(i, 1);
      }
    },
    lookClick(val) {
      this.chainData.sceneImgUrl = val;
    },
    saveClick(val) {
      this.chainData.sceneImgList = val;
    },
    async remoteMethod(query) {
      if (!query) {
        return;
      }
      const res = await selectAssociatedScenarios({ sceneName: query });
      if (res.code == 200) {
        this.sceneList = res.data;
      }
    },
    async remoteMethods(query) {
      if (!query) {
        return;
      }
      const res = await selectAssociated({ sceneName: query });
      if (res.code == 200) {
        this.sceneArr = res.data;
      }
    },
    async remoteMethodsss(query) {
      if (!query) {
        return;
      }
      const res = await getProductByName({ productName: query });
      if (res.code == 200) {
        this.sceneArr1 = res.data;
      }
    },
    async remoteMethodssss(query) {
      if (!query) {
        return;
      }
      const res = await getZcByCompanyName({ companyFullName: query });
      if (res.code == 200) {
        this.sceneArr2 = res.data;
      }
    },
    async getAllScenarioProcess(query) {
      const res = await getAllScenarioProcess({ labelName: query });
      if (res.code == 200) {
        this.rocessList = res.data;
      }
    },
    clickCompany(val) {
      val.forEach((el) => {
        this.sceneArr2.forEach((o) => {
          if (el == o.id) {
            this.associatedCompanyNameList.push(o);
          }
        });
      });
    },
   // 获取企业行为
    async getDicRadioButton() {
      const res = await getDicRadioButton({ code: "046" });
      if (res.code == 200) {
        this.behaviorOptions = res.data;
      }
    },

    // 获取产业链
    async selectAllIndustrialChainName(query) {
      const res = await selectAllIndustrialChainName({ name: query });
      if (res.code == 200) {
        this.industrialChainOptions = res.data;
      }
    },

    //获取行业标签
    async getIndustryThree() {
      const res = await getIndustryLabelFour({
        groupLabelType: "国民经济行业标签组",
        level: 3,
      });
      if (res.code == 200) {
        this.industryThreeOptions = res.data;
        this.industrylist = [
          {
            typelist: this.industryThreeOptions, //一级标签
            codechildlist1: [],
            childlist: [],
            childlist4: [],
            childcode5: [],
            childcode6: [],
            labelparam1: [],
            labelparam2: [],
            labelparam3: [],
            labelparam4: [],
            labelparam5: [],
            labelparam6: [],
          },
        ];
      }

    },


    async search() {
      const res = await selectById({ id: this.personData });
      if (res.code == 200) {
        // Object.assign(this.chainData, res.data);
        this.chainData = res.data;

        this.remoteMethods(this.chainData.superiorBehaviorName);

        if (!this.chainData.productResults) {
          this.chainData.productResults = [];
        } else {
          this.sceneArr1 = this.chainData.productResults;
        }
        this.remoteMethod(this.chainData.superiorSceneName);

        // this.remoteMethodssss(this.chainData. associatedCompanyName)
        this.sceneArr2 = this.chainData.companyVoList;

        if (this.chainData.companyVoList) {
          this.chainData.associatedCompanyIdList = [];
          this.chainData.companyVoList.forEach((el) => {
            this.chainData.associatedCompanyIdList.push(el.id);
            this.associatedCompanyNameList.push(el);
          });
        }

        this.remoteMethodsss("");

        if (this.chainData.incomeList) {
          this.qianList1 = this.chainData.incomeList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //收益
        }
        if (this.chainData.shortTermGainsList) {
          this.qianList2 = this.chainData.shortTermGainsList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //短期收益
        }
        if (this.chainData.longTermReturnsList) {
          this.qianList3 = this.chainData.longTermReturnsList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //长期收益
        }
        if (this.chainData.manageRisksList) {
          this.qianList4 = this.chainData.manageRisksList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //管理风险
        }
        if (this.chainData.technologicalRisksList) {
          this.qianList5 = this.chainData.technologicalRisksList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //技术风险
        }
        if (this.chainData.complianceRiskList) {
          this.qianList6 = this.chainData.complianceRiskList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //合规风险
        }
        if (this.chainData.organizationalRiskList) {
          this.qianList7 = this.chainData.organizationalRiskList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //组织风险
        }
        if (this.chainData.publicOpinionRiskList) {
          this.qianList8 = this.chainData.publicOpinionRiskList.map((item) => {
            item = {
              name: item,
            };
            return item;
          }); //组织风险
        }

        if (!this.chainData.industryLabelList) {
          this.chainData.industryLabelList = [];
        } else {
          let list = [];
          let arr = [];
          this.chainData.industryLabelList.forEach((el, index) => {
            if (el.indexOf(",", 0) != -1) {
              arr = this.chainData.industryLabelList[index].split(",");
              arr.forEach((o, i) => {
                list.push(Number(o));
              });
            } else {
              list.push(Number(el));
            }
          });
          if (list.length) {
            this.chainData.industryLabelList = Array.from(new Set(list));
          }
        }
        if (!this.chainData.industrialChainLabelList) {
          this.chainData.industrialChainLabelList = [];
        } else {
          let list = [];
          let arr = [];
          this.chainData.industrialChainLabelList.forEach((el, index) => {
            if (el.indexOf(",", 0) != -1) {
              arr = this.chainData.industrialChainLabelList[index].split(",");
              arr.forEach((o, i) => {
                list.push(Number(o));
              });
            } else {
              list.push(Number(el));
            }
          });
          if (list.length) {
            this.chainData.industrialChainLabelList = Array.from(new Set(list));
          }
        }
        if (this.chainData.updateTime) {
          this.chainData.updateTimes = this.timestampToTime(
            this.chainData.updateTime
          );
        }
        if (this.chainData.createTime) {
          this.chainData.createTimes = this.timestampToTime(
            this.chainData.createTime
          );
        }
        if (!this.chainData.enterpriseBehaviorLabels) {
          this.chainData.enterpriseBehaviorLabels = [];
        }

        if (!this.chainData.temporaryProductImg) {
          this.chainData.sceneImgList = [];
        } else {
          this.chainData.sceneImgUrl = this.chainData.temporaryProductImg;
        }
        if (!this.chainData.temporaryProductImg) {
          this.chainData.sceneImgUrl = [];
        }
      } else {
        this.$message.error("查询失败");
      }
    },

    cancelItem() {
      this.$router.go(-1);
    },
    handleClose(tag) {
      const index = this.chainData.fatherIds.indexOf(tag);
      this.chainData.fatherIds.splice(index, 1);
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

      var Y = date.getFullYear() + "-";

      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";

      var D = date.getDate();

      var h = date.getHours();

      var m = date.getMinutes();

      var s = date.getSeconds();

      return (
        Y +
        M +
        this.add0(D) +
        " " +
        this.add0(h) +
        ":" +
        this.add0(m) +
        ":" +
        this.add0(s)
      ); //时分秒可以根据自己的需求加上
    },
    updateCode(val, tag) {
      switch (tag) {
        case "领域":
          this.chainData.supplyChainIndustryChild = val;
          break;

        case "行业":
          this.chainData.supplyChainIndustryChild = val;
          break;

        case "技术":
          this.chainData.supplyChainIndustryChild = val;
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-radio {
  color: #606266;
  cursor: pointer;
  margin-right: 30px;
  margin-bottom: 10px;
  margin-top: 10px;
}
svg {
  font-size: 14px;
}
.mainTop {
  background-color: white;
  padding: 20px 20px 0 20px;
  // margin-bottom: 20px;
}
.circle_flex {
  width: 680px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.content {
  overflow: auto;

  width: 100%;
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  background-color: grey; /*滚动条的背景颜色*/
}

.ess_people {
  display: flex;
  flex-direction: column;
  // overflow: hidden;
  margin: 20px 30px;
  align-content: center;

  .ess_people_list {
    width: 100%;
    margin: 4px 0;
    color: #7c7f8e;
    font-size: 12px;
  }
}
.border_flex {
  display: flex;
  align-items: center;
  margin-left: 10px;
  padding: 5px 0px;
}
.border_left {
  width: 3px;
  height: 20px;
  background: #1e9fff;
  display: inline-block;
  margin-right: 5px;
}
// 上传
/deep/ .el-upload--picture-card {
  width: 200px !important;
  height: 150px !important;
  line-height: 150px !important;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 200px;
  height: 150px;
  // line-height: 150px;
}
/deep/ .el-upload {
  background-color: #fff;
}
/deep/.el-input {
  width: 470px !important;
}
// /deep/.el-textarea {
//   width: 80% !important;
//   // min-height: 40px !important;
// }
/deep/ .el-icon-circle-plus-outline {
  font-size: 31px;
  vertical-align: middle;
  color: #698eef;
  cursor: pointer;
  padding-left: 10px;
}
.bottomStyle {
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 150px !important;
    height: 100px !important;
    line-height: 100px !important;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 150px;
    height: 100px;
    // line-height: 150px;
  }
  /deep/ .el-upload {
    background-color: #fff;
  }
}
/deep/ .el-icon-remove-outline {
  font-size: 31px;
  vertical-align: middle;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}
.flexStyle {
  display: flex;
  margin: 10px 10px 10px 0;
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 20px 20px;
  display: flex;
  justify-content: center;

  .el-button {
    margin: 0 20px;
  }
}
/deep/ .el-tag.el-tag--info {
  background: rgba(30, 159, 255, 0.2);
  color: rgb(30, 159, 255);
}
/deep/ .el-tag.el-tag--info .el-tag__close {
  color: rgb(30, 159, 255);
  background: rgba(30, 159, 255, 0.2);
}
</style>
